import React, { useEffect, useRef, useState } from "react";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../../../authConfig";
import { callMsGraph } from "../../../graph";
import { ReactComponent as Profile } from "../../../assets/icons/profile.svg";
import { ReactComponent as Dots } from "../../../assets/icons/dots-vertical.svg";
import { ReactComponent as Plane } from "../../../assets/icons/plane.svg";

export const SignOutButton = () => {
  const { instance, accounts } = useMsal();
  const [graphData, setGraphData] = useState<any>(null);
  const [showDropdown, setShowDropdown] = useState(false);
  const ref = useRef(null);

  console.log(showDropdown);

  useEffect(() => {
    instance
      .acquireTokenSilent({
        ...loginRequest,
        account: accounts[0],
      })
      .then((response) => {
        callMsGraph(response.accessToken).then((response) =>
          setGraphData(response)
        );
      });
  }, [instance, loginRequest]);

  const handleLogout = (logoutType: String) => {
    if (logoutType === "popup") {
      instance.logoutPopup({
        postLogoutRedirectUri: "/",
        mainWindowRedirectUri: "/",
      });
    } else if (logoutType === "redirect") {
      instance.logoutRedirect({
        postLogoutRedirectUri: "/",
      });
    }
  };

  return (
    <>
      <div ref={ref} className="relative min-w-[260px]">
        <button
          type="button"
          id="dropdownDefaultButton"
          data-dropdown-toggle="dropdown"
          className="w-full flex items-center justify-between px-4 py-3 gap-3 rounded-[26px] border border-off-white-opacity text-sm hover:bg-dark-gray"
          onClick={() => setShowDropdown(!showDropdown)}
        >
          <Profile className="w-5 h-5 rounded-full bg-gray" />
          <span>
            Welcome <strong>{graphData?.displayName}</strong>
          </span>
          <Dots />
        </button>
        {showDropdown && (
          <div
            id="dropdown"
            className="w-full bg-background rounded-xl border border-off-white-opacity absolute top-14 left-0 z-50 overflow-hidden"
          >
            <ul
              className="text-sm text-light-gray font-bold"
              aria-labelledby="dropdownDefaultButton"
            >
              <li>
                <a
                  className="block p-6 hover:bg-dark-gray flex justify-between"
                  href="https://corexperience.sharepoint.com/sites/CoreX/SitePages/Home.aspx"
                  target="_blank"
                >
                  Visit your Microsoft Account
                  <Plane />
                </a>
              </li>
              <li>
                <button
                  className="p-6 hover:bg-dark-gray w-full flex justify-between"
                  onClick={() => handleLogout("popup")}
                >
                  Sign Out
                  <Plane />
                </button>
              </li>
            </ul>
          </div>
        )}
      </div>
    </>
  );
};
